export const subtitles = {
    "1": {
        "startTime": 1.5,
        "endTime": 4.5,
        "transcript": "Waten tang ayuqellrullinilriakut…",
        "translation": "You see, we were like this…"
    },
    "2": {
        "startTime": 4.9,
        "endTime": 7.0,
        "transcript": "…iliinun ukuk Oscar-aankuk.",
        "translation": "…some of it from Oscar and the other."
    },
    "3": {
        "startTime": 7.5,
        "endTime": 11.9,
        "transcript": "Waten au͡gna imna qanrutkeqerlaku.",
        "translation": "Let me speak about it like this."
    },
    "4": {
        "startTime": 12.0,
        "endTime": 18.0,
        "transcript": "Qaneryaraq cakaarciigataqa nallunriqka wii ilii.",
        "translation": "I can't ignore part of the Bible that I learned."
    },
    "5": {
        "startTime": 19.0,
        "endTime": 20.5,
        "transcript": "Amlleq nalluyaaqaqa.",
        "translation": "There is a lot I don't know."
    },
    "6": {
        "startTime": 21.8,
        "endTime": 26.8,
        "transcript": "Angutet iliit apervikuagarluni wangnun.",
        "translation": "One of the men confessed to me."
    },
    "7": {
        "startTime": 27.9,
        "endTime": 33.0,
        "transcript": "Tuyuulallemni ayagcetaulua apervikuagarluni iliit qanertuq",
        "translation": "When I was a lay pastor, one of them said in a confession"
    },
    "8": {
        "startTime": 34.0,
        "endTime": 37.0,
        "transcript": "Qavangurtulria-gguq tang unuk.",
        "translation": "That he had a dream the night before."
    },
    "9": {
        "startTime": 38.0,
        "endTime": 43.0,
        "transcript": "Ellii tua-i assiilkelluku tamana qavanguni.",
        "translation": "He didn't like his dream."
    },
    "10": {
        "startTime": 44.3,
        "endTime": 49.0,
        "transcript": "Ellii-gguq ellminek tangertuq uquriqapiggluni waten.",
        "translation": "He said that he saw himself as very fat like this."
    },
    "11": {
        "startTime": 50.3,
        "endTime": 54.0,
        "transcript": "Pinirluni, cagniluni, uquriluni.",
        "translation": "He was strong, tough, and fat."
    },
    "12": {
        "startTime": 55.5,
        "endTime": 65.0,
        "transcript": "Tua-llu-gguq tauna kenkek'ngani irniami iliit anngaqliq tangrraa ellminek tangrraarluni.",
        "translation": "And then, he said that he saw one of children whom he loved, the eldest son, after looking at himself."
    },
    "13": {
        "startTime": 65.5,
        "endTime": 69.0,
        "transcript": "Tuana-gguq tua-i kemgitqapiarluni.",
        "translation": "He said [his son] was very skinny."
    },
    "14": {
        "startTime": 70.0,
        "endTime": 76.5,
        "transcript": "Tua-i takumcunaqluni. Enri-llu makut amimek tau͡gaam caqumaluteng.",
        "translation": "He was pitiful. And his bones were only covered by skin."
    },
    "15": {
        "startTime": 78.9,
        "endTime": 86.0,
        "transcript": "Tua-i-gguq cakneq kenkataqngamiu ellminek ciknakuq umyuamikun.",
        "translation": "He said that he envied himself because he loved him so much."
    },
    "16": {
        "startTime": 86.5,
        "endTime": 93.0,
        "transcript": "Ellminek ciknakluni, “Ciin wii uqurisia? Una-llam tau͡gaam uqurinrilnguq.”",
        "translation": "Envying himself, “Why am I fat? He should be fat.”"
    },
    "17": {
        "startTime": 94.9,
        "endTime": 99.0,
        "transcript": "Tua-llu taringartarci? Taringesciigatarci-ll' tayima.",
        "translation": "Do youpl understand it? Youpl might not understand it."
    },
    "18": {
        "startTime": 99.8,
        "endTime": 106.2,
        "transcript": "Tua-llu-gguq taringevkaumauq waten tauna qavangurtulleq:",
        "translation": "And then the one who had the dream understood this:"
    },
    "19": {
        "startTime": 106.9,
        "endTime": 118.0,
        "transcript": "Elpet Qaneryaraq tamalkuan nallunritan, ayuqucirkaq-llu maani nunam qaingani nalluvkenaku.",
        "translation": "You know the entire Bible, and you know how one should be on the earth."
    },
    "20": {
        "startTime": 119.0,
        "endTime": 126.3,
        "transcript": "Tau͡gken elpet tuaten ayuqeng'e'rpet irniaten ukut qalarucuunaki",
        "translation": "Yet even though you're like that, you don't instruct your children"
    },
    "21": {
        "startTime": 127.9,
        "endTime": 134.8,
        "transcript": "Qalarucuilavteng waniw' kemgitut. Elpet elisngaluten uquriuten.",
        "translation": "They're skinny because you don't instruct them. You are fat in your knowledge."
    },
    "22": {
        "startTime": 135.5,
        "endTime": 141.0,
        "transcript": "Tua-llu? Au͡g'umun kanaqerlua piunga. Nall'artaqa-qaa ukut qalartellrat?",
        "translation": "Well? I digressed with that. Am I in accordance with what they're saying?"
    },
    "23": {
        "startTime": 141.9,
        "endTime": 146.5,
        "transcript": "Tua-ll' ayuquciitua Kass'atun. Anitia enairqe'rqa.",
        "translation": "And then, I don't know English. I took Anitia's place."
    },
    "24": {
        "startTime": 147.0,
        "endTime": 149.5,
        "transcript": "Qaillun promote-aq mumigcarauga?",
        "translation": "How is “promote” translated?"
    },
    "25": {
        "startTime": 150.0,
        "endTime": 155.0,
        "transcript": "Taringumanritaqa “promote the heritage” waten qanelria una. (Ciumurulluku.)",
        "translation": "I don't understand what “promote the heritage” says here. (To bring it forth.)"
    },
    "26": {
        "startTime": 155.5,
        "endTime": 157.0,
        "transcript": "Kitak' nalqiguteqercia. (Ciumurulluku.)",
        "translation": "Please explain it to me. (To bring it forth.)"
    },
    "27": {
        "startTime": 158.8,
        "endTime": 161.5,
        "transcript": "Niicuitua. (Ciumurulluku.)",
        "translation": "I'm hard of hearing. (To bring it forth.)"
    },
    "28": {
        "startTime": 161.6,
        "endTime": 165.2,
        "transcript": "Ciumurulluku yuullerkaq, qaa?",
        "translation": "To bring forth a way of life, right?"
    },
    "29": {
        "startTime": 165.8,
        "endTime": 169.3,
        "transcript": "Ii-i, kitak' ellmarraquiner piqerlaut.",
        "translation": "Okay, let's [cover] a small part of it."
    },
    "30": {
        "startTime": 170.5,
        "endTime": 175.5,
        "transcript": "Wangkuta, wangkutnek-wa tua-i wangni",
        "translation": "We, us for me personally"
    },
    "31": {
        "startTime": 176.0,
        "endTime": 180.5,
        "transcript": "Naliata akwaugaq qanrutaanga, Ayaprucaraam piyugnarqaanga",
        "translation": "One of them told me yesterday, it may have been Ayapruca'ar"
    },
    "32": {
        "startTime": 181.3,
        "endTime": 195.5,
        "transcript": "Wangkutnek wii nallemnek tuar tang ayagluta wangkutnek man'a Yuum ayallra cimilira. Qaa?",
        "translation": "From our time, it seems that starting from us, where a Yup'ik is going is changing. Right?"
    },
    "33": {
        "startTime": 197.2,
        "endTime": 200.2,
        "transcript": "Kass'atun makut kinguqliput ellirtut.",
        "translation": "Our descendants here are becoming Westernized."
    },
    "34": {
        "startTime": 202.4,
        "endTime": 207.5,
        "transcript": "Kass'arngariut, ilait-llu Yugtun taringesciigaliluteng.",
        "translation": "They're becoming Westernized, and some understand Yup'ik anymore."
    },
    "35": {
        "startTime": 209.5,
        "endTime": 212.0,
        "transcript": "Kass'aturrlainaq tau͡gaam qalarqurangluteng.",
        "translation": "They've started only speaking completely in English."
    },
    "36": {
        "startTime": 213.5,
        "endTime": 220.4,
        "transcript": "Tua-ll' waniw' Yugtun yuullerkam ayuqucianek piyaaqengramta",
        "translation": "And then even if we [teach] what a person must be like living a Yup'ik life"
    },
    "37": {
        "startTime": 220.7,
        "endTime": 226.5,
        "transcript": "Makut tamakut Kass'atun elitellriit qaillun elitnauqatarceta?",
        "translation": "How are we going to teach those who've learned English?"
    },
    "38": {
        "startTime": 228.5,
        "endTime": 241.4,
        "transcript": "Ataam-qaa au͡gna yuktallerput tengruluteng ataam ayagniryugngaciqait caknerluta wangkuta yuullerput?",
        "translation": "Will our dear children be able to enthusiastically begin [living] our lives where we struggled?"
    },
    "39": {
        "startTime": 242.5,
        "endTime": 248.5,
        "transcript": "Qimugtetgun-llu ayagaluta kayimngina'arturluta-llu qugtatullruluta Akulmi.",
        "translation": "We would travel with dog teams, and we would gather wood by pushing sleds in the Akula region."
    },
    "40": {
        "startTime": 249.5,
        "endTime": 252.5,
        "transcript": "Qimugtaunata-llu ayagatullruluta.",
        "translation": "We also used to travel without dogs."
    },
    "41": {
        "startTime": 252.9,
        "endTime": 259.0,
        "transcript": "Qanikciurutput-llu elluatuullruvkenateng, piqertuutaput-llu elluatuullruvkenateng.",
        "translation": "Also, our shovels were not convenient, and our axes were not convenient."
    },
    "42": {
        "startTime": 260.0,
        "endTime": 263.0,
        "transcript": "Wangkuta ciuqlirpeceńi",
        "translation": "We, yourpl elders"
    },
    "43": {
        "startTime": 263.8,
        "endTime": 270.9,
        "transcript": "Makut tua-llu-w' nutaan ciuqliput nutaan tangrruarqamteng nutaan caknepiallruyugnarqut.",
        "translation": "And when I imagine our elders, they probably struggled a lot more."
    },
    "44": {
        "startTime": 271.7,
        "endTime": 280.3,
        "transcript": "Ukatmun Kass'at tungiitnun calissuutait call' tungiitnun ayallerput maliggluku tuarpiaq qacignariinarluteng cat.",
        "translation": "As we became more Westernized and using their tools, it seems that things have been getting easier."
    },
    "45": {
        "startTime": 280.9,
        "endTime": 290.0,
        "transcript": "Waniwa-ll' yaaqsingraan wanirpaagaq tekiarcaurrluku wangkuta unuakuayaarmek ayagluta caqtarturatullerput.",
        "translation": "And now, they've started reaching far places right away where we used to strive to reach starting early in the morning."
    },
    "46": {
        "startTime": 291.5,
        "endTime": 295.0,
        "transcript": "Tua-llu? Maa-i taringarci man'a?",
        "translation": "Well? Do youpl understand this?"
    },
    "47": {
        "startTime": 296.9,
        "endTime": 299.0,
        "transcript": "Anagarutengqatalliunga?",
        "translation": "I might speak too excessively."
    },
    "48": {
        "startTime": 299.8,
        "endTime": 304.5,
        "transcript": "Ataku, atata… waten qanruarteqernaamci:",
        "translation": "Later… let me tell you this:"
    },
    "49": {
        "startTime": 305.0,
        "endTime": 312.5,
        "transcript": "Kass'atun elisnganritua. Uumek-am entertain-amek igangua maaken.",
        "translation": "I'm not fluent in English. I've received a letter from here concerning entertainment."
    },
    "50": {
        "startTime": 312.8,
        "endTime": 320.5,
        "transcript": "George [?]-arluni igartuq, entertain-aaryugtua-gguq-qaa maani Elders' Conference-aaratni.",
        "translation": "George [?] wrote asking if I wanted to entertain here at the Elders' Conference."
    },
    "51": {
        "startTime": 321.0,
        "endTime": 327.0,
        "transcript": "Wii tua-i ayuquciilamku ukut ilaitnek qanerkitqataryuklua",
        "translation": "Because I didn't know what it meant, I thought they would give me one of these to say"
    },
    "52": {
        "startTime": 327.5,
        "endTime": 331.4,
        "transcript": "“Paitaput aturluki avani ciunerkamteńi.”",
        "translation": "“Following our legacies in our future.”"
    },
    "53": {
        "startTime": 331.5,
        "endTime": 338.2,
        "transcript": "Ukut ilaitnek wangni qanerkitqataryuklua angerluku tauna apqaurteka.",
        "translation": "Thinking that I was going to be given one of these to say, I agreed to the one who asked me."
    },
    "54": {
        "startTime": 338.3,
        "endTime": 340.0,
        "transcript": "Uungullilria-w' tua-i.",
        "translation": "This is probably what it is."
    },
    "55": {
        "startTime": 341.5,
        "endTime": 347.5,
        "transcript": "Tua-i-llu waniw' taringaqa angniqercetaarcuutngullinilria.",
        "translation": "And now, I understand that it's a form of fun."
    },
    "56": {
        "startTime": 347.6,
        "endTime": 355.0,
        "transcript": "Ava-i-ll' ciuqliinka entertainment-aamun tekitaqan murilkenqegcaarqamteng akwaugarnek",
        "translation": "As I've been watching those before me when it comes to this entertainment"
    },
    "57": {
        "startTime": 355.5,
        "endTime": 358.5,
        "transcript": "Aturluteng, yurarluteng tuaten pinaurtut.",
        "translation": "They sing, and even Yup'ik dance."
    },
    "58": {
        "startTime": 359.0,
        "endTime": 362.9,
        "transcript": "Wiinga atuyuitua. Erinallugtua.",
        "translation": "I don't sing. I have a bad voice."
    },
    "59": {
        "startTime": 363.3,
        "endTime": 369.5,
        "transcript": "Cali-llu yuraqtatullruyaaqua tua-i tau͡gaam maa-i yurayuunii.",
        "translation": "Also, I used to Yup'ik, but I don't now."
    },
    "60": {
        "startTime": 370.0,
        "endTime": 377.4,
        "transcript": "Tau͡gaam temcinarqellriamek piarkaukuma ataku 2:00 quuyurniqercecugngaciqamci.",
        "translation": "But if I have to do something funny later at 2:00, I can make youpl smile."
    },
    "61": {
        "startTime": 377.5,
        "endTime": 380.0,
        "transcript": "Tua-i tuaten pitaluki. Amlleriut.",
        "translation": "That's all from me. It's enough."
    },
    "62": {
        "startTime": 384.5,
        "endTime": 386.0,
        "transcript": "…nritaraurtut allrakut.",
        "translation": "…years have passed."
    },
    "63": {
        "startTime": 387.5,
        "endTime": 396.0,
        "transcript": "Tamakut ciuliamta qaneryaraqlallrit taringyaurrluki eglellruyaaqua.",
        "translation": "I had started understanding our ancestors' traditional wisdom as I've gone in life."
    },
    "64": {
        "startTime": 397.3,
        "endTime": 403.5,
        "transcript": "Tauna-llu Ellam Yua maa-i watua Agayutmek piyaurtelliniat.",
        "translation": "Now, they've also started referring to the Spirit of the Universe as [the Christian] God."
    },
    "65": {
        "startTime": 404.3,
        "endTime": 410.0,
        "transcript": "Una cali qilak pamanelngurmek atengqe[rrluni].",
        "translation": "This qilak is now also the name of [Heaven] above."
    },
    "66": {
        "startTime": 410.5,
        "endTime": 419.0,
        "transcript": "…nunarraat iqlutun eglengqata'arpaka'arqata taum angalkum elluatmun eglerutetullrullinii.",
        "translation": "…when villages started going the wrong way, that shaman would steer them the right way."
    },
    "67": {
        "startTime": 419.5,
        "endTime": 422.8,
        "transcript": "Tau͡gaam wangnek alingyagullua…",
        "translation": "But because I started being afraid of myself…"
    },
    "68": {
        "startTime": 424.0,
        "endTime": 429.0,
        "transcript": "Merquumek atengqellruyaaqelliniuq avani ciuqvaarni.",
        "translation": "It used to be called a water offering a long time ago."
    },
    "69": {
        "startTime": 432.0,
        "endTime": 434.5,
        "transcript": "Man'a cali aviukarcaraq…",
        "translation": "Also, this way of food or water offerings…"
    },
    "70": {
        "startTime": 435.0,
        "endTime": 440.5,
        "transcript": "…catairutleq umyuaqluku aviukarqetullrulliniluta.",
        "translation": "…we evidently used to offer food or water for the deceased."
    },
    "71": {
        "startTime": 445.8,
        "endTime": 448.9,
        "transcript": "Tamaa-i tamakut taringyaurcaaqellrenka.",
        "translation": "That's what I started to understand."
    },
    "72": {
        "startTime": 449.3,
        "endTime": 453.5,
        "transcript": "Qemangqavakaamki ancaurtanka.",
        "translation": "I've ended up talking about them since I've held them for so long."
    },
    "73": {
        "startTime": 453.6,
        "endTime": 456.9,
        "transcript": "Mat'um ukvemta…",
        "translation": "Our belief…"
    },
    "74": {
        "startTime": 457.8,
        "endTime": 466.0,
        "transcript": "…taumek picirluki maa-i ayagyuaput, tamana pitekluku.",
        "translation": "…for that reason, [we do that] to our young people."
    },
    "75": {
        "startTime": 468.0,
        "endTime": 478.5,
        "transcript": "Wangkuta assinrilngurmek ellalirturnayukluki alerquayuirutellriatun ayuqelliniaput.",
        "translation": "We have apparently stopped insetruction them because we might teach them something bad."
    },
    "76": {
        "startTime": 479.7,
        "endTime": 487.0,
        "transcript": "Maani wangkuta ilamta ukvellgutkenrilamta tamana piciryararput…",
        "translation": "Because some of us here have different beliefs, our traditional custom…"
    },
    "77": {
        "startTime": 489.4,
        "endTime": 493.5,
        "transcript": "…maa-i tau͡gaam allragnirpak katurcaurcamta",
        "translation": "…but since we've started holding meetings since last year"
    },
    "78": {
        "startTime": 494.0,
        "endTime": 503.0,
        "transcript": "Qayugg' ukvellgutkenrilnguut agayulirtet katurrluteng taringengiinaraat tamana avani ciuqvaarni yuucillerput.",
        "translation": "Priests who have different beliefs meet and have started understanding our ancient way of life more and more."
    },
    "79": {
        "startTime": 504.0,
        "endTime": 506.0,
        "transcript": "Eyagyaraq cali.",
        "translation": "Including abstinence."
    },
    "80": {
        "startTime": 508.0,
        "endTime": 511.0,
        "transcript": "Wiinga waniwa nallunrilkevcia.",
        "translation": "Youpl know me."
    },
    "81": {
        "startTime": 511.1,
        "endTime": 518.0,
        "transcript": "Maani Kusquqvagmi ellangellrulrianga man'a tua-i Kusquqvak kuikluku.",
        "translation": "In my earliest memories of the Kuskokwim here, the Kuskokwim was our main river."
    },
    "82": {
        "startTime": 519.5,
        "endTime": 522.0,
        "transcript": "Alcimek Yugtun atengqerrlua.",
        "translation": "Alciq is my Yup'ik name."
    },
    "83": {
        "startTime": 522.5,
        "endTime": 542.0,
        "transcript": "Tua-i-llu waniwa nallunritlemteńi uumek akwaugaq imna qanqautekelqa teggutekqerluku, teggutekqerluku.",
        "translation": "And then from what I know, I talked yesterday about using it for support."
    },
    "84": {
        "startTime": 544.0,
        "endTime": 554.0,
        "transcript": "Nunam yuini wangkuta mat'umek ak'allarpall'ermek ayuqucirtuutmek teggutengqertukut tua-i taumek.",
        "translation": "We people of the land have this extremely ancient instruction as our support."
    },
    "85": {
        "startTime": 555.9,
        "endTime": 562.8,
        "transcript": "Man'a-llu teggutvut takarnaqpiarluni takarnairucuunani-llu.",
        "translation": "And our support should be respected, and should always be respected."
    },
    "86": {
        "startTime": 563.0,
        "endTime": 577.0,
        "transcript": "Makuni maa-i watua tegganeruaramteńi makuni tamatumi takarnarquciq uitauq.",
        "translation": "For us elders today, that cause for respect is there."
    },
    "87": {
        "startTime": 578.6,
        "endTime": 590.5,
        "transcript": "Takarnarqelriim cam imum tamatum nunam yui tamakut tegguciumaluki.",
        "translation": "That thing we must respect supports the people of the earth."
    },
    "88": {
        "startTime": 590.8,
        "endTime": 596.0,
        "transcript": "Tauna-llu tegguciumasteseng ellaita nalluvkenaku.",
        "translation": "They also know who supports them."
    },
    "89": {
        "startTime": 597.0,
        "endTime": 604.0,
        "transcript": "Taumek man'a ak'allaq ukanirpak tailria teggutek'ngamteggu",
        "translation": "Because we have always been supported by this ancient thing"
    },
    "90": {
        "startTime": 605.2,
        "endTime": 612.5,
        "transcript": "Tua-i nangerngatekluku-llu calritarau͡rlulriani maani nangerngaurlurtukut.",
        "translation": "And it supports our lives, we dear healthy ones here are standing."
    },
    "91": {
        "startTime": 614.0,
        "endTime": 627.5,
        "transcript": "Man'a-llu waten ayuqucirput yuum taum atra, Yugtun atra tua-i pirpakarput.",
        "translation": "And the way we are towards a person's name, we consider his Yup'ik name important."
    },
    "92": {
        "startTime": 629.0,
        "endTime": 636.4,
        "transcript": "Cali-llu Yugtun qanerturalleq cali una pirpakarput Yuungamta tua-i.",
        "translation": "We also consider the Yup'ik language important because we are Yupiit."
    },
    "93": {
        "startTime": 637.5,
        "endTime": 645.5,
        "transcript": "Tauna arcaqerluku akulemteńi aterpagtaarturaulluta quyanaqpiartuq.",
        "translation": "I'm very thankful that we call each other [by our Yup'ik names] among ourselves."
    },
    "94": {
        "startTime": 646.7,
        "endTime": 653.0,
        "transcript": "Tuamta-llu wangkuta Yugni uumek tua-i nalluvkenata:",
        "translation": "And then, we Yupiit know this:"
    },
    "95": {
        "startTime": 654.4,
        "endTime": 665.5,
        "transcript": "Atunem ciuniurtaagutlerput, atunem-llu tua-i ilaliurutlerput uuggun elluarucikun ilaliurucarakun.",
        "translation": "Welcoming each other, and treating each other the way we should treat each other well."
    },
    "96": {
        "startTime": 666.3,
        "endTime": 675.8,
        "transcript": "Tua-i una wani waten ayuqellerput caknerpak akulemteńi angkacagartuq.",
        "translation": "That's why this way we are is extremely important among us."
    },
    "97": {
        "startTime": 676.0,
        "endTime": 683.0,
        "transcript": "Takarnarqucia-llu tua-i tuaten ayuqerrlainarluni takarnairucuunani-llu.",
        "translation": "It's need for respect is always like that, and it should always be respected."
    },
    "98": {
        "startTime": 684.0,
        "endTime": 692.0,
        "transcript": "Taumek tua-i makut makunun kingumteńun ayagyuanun makunun",
        "translation": "That's why for our descendats, the young people here"
    },
    "99": {
        "startTime": 696.0,
        "endTime": 706.5,
        "transcript": "Elitnaurutmeggnek elitelartut mat'um Kassauryaarturluteng atunem qanerturaucimeggnek.",
        "translation": "From they education, they learn how to speak English to each other."
    },
    "100": {
        "startTime": 707.4,
        "endTime": 712.0,
        "transcript": "Tamana-llu elisngaarteng ilumun kingumek",
        "translation": "And indeed, what they have learned later"
    },
    "101": {
        "startTime": 717.8,
        "endTime": 728.2,
        "transcript": "Ellmeggnun angayuqaagminek ukugnek ciumek elitellni tauna elliin ciumek elitaa-qaa?",
        "translation": "Does one first learn from what he has been taught by his parents?"
    },
    "102": {
        "startTime": 731.3,
        "endTime": 738.0,
        "transcript": "Una-llu Kassauyaarturyaraq kingumek elitaaqluku tua-i.",
        "translation": "And then they learn to be Westernized later."
    },
    "103": {
        "startTime": 739.8,
        "endTime": 746.0,
        "transcript": "Tauna cali elliini tauna Yugmi ayagyuami uitauq.",
        "translation": "That is also in that young Yup'ik person."
    },
    "104": {
        "startTime": 746.5,
        "endTime": 752.5,
        "transcript": "Angayuqaagminek ciumek elitellruami tua-i elliini uitauq.",
        "translation": "It's in him since he first learned from his parents."
    },
    "105": {
        "startTime": 752.8,
        "endTime": 760.5,
        "transcript": "Una-llu Kassauyaarturyaraq tua-i cali elliini uitaluni elitnaurutekngamiu.",
        "translation": "This Westernization is also in him since it was taught to him."
    },
    "106": {
        "startTime": 761.0,
        "endTime": 764.0,
        "transcript": "Tua-i uumek nallunritukut:",
        "translation": "We know this:"
    },
    "107": {
        "startTime": 765.8,
        "endTime": 775.0,
        "transcript": "Una wani yuk yuum uum tegularaqamiu tegulatua, unatain-llu…",
        "translation": "When a person takes another, he takes him and his hands…"
    },
    "108": {
        "startTime": 775.5,
        "endTime": 780.5,
        "transcript": "…[kesianek] elitnaurutemteńek exercise-arluta pituukut.",
        "translation": "…we [always] exercise as we were taught."
    },
    "109": {
        "startTime": 781.0,
        "endTime": 791.0,
        "transcript": "Yuraryaraq, yuraryararteng man'a aturaqamegteggu angnirluteng, quyaluteng, engelaraqluteng-llu pituluteng.",
        "translation": "When they follow their Yup'ik dancing tradition, they're happy, thankful, and they laugh."
    },
    "110": {
        "startTime": 792.0,
        "endTime": 793.0,
        "transcript": "Tua-i.",
        "translation": "There you have it."
    },
    "111": {
        "startTime": 794.0,
        "endTime": 803.5,
        "transcript": "Man'a, ilumun man'a atuqengarput maa-i watua elisngalriit tamakut",
        "translation": "Truly, these knowledgable people [must use] what we are living now"
    },
    "112": {
        "startTime": 805.8,
        "endTime": 813.5,
        "transcript": "Elitaarteng makunun qatellrianun inglutuutekluku caliarkaqaat.",
        "translation": "They must work to oppose these Caucasians with what they learned."
    },
    "113": {
        "startTime": 814.0,
        "endTime": 819.5,
        "transcript": "Una assilriim tungiinun caliarteng caliaqerkaugaat.",
        "translation": "They must work for the good [of our people]."
    },
    "114": {
        "startTime": 819.9,
        "endTime": 828.0,
        "transcript": "Ilumun-llu ciumurutellerkaa assilriim tungiinun tengrunaqluni assirluni.",
        "translation": "And truly, it's exciting and good to work for the good [of our people]."
    },
    "115": {
        "startTime": 829.5,
        "endTime": 844.8,
        "transcript": "Uum wani ciumurucaram avani yaaqvaarni egmianun nallunrirluku pinrilnge'rmiu",
        "translation": "This bringing forth [goodness], even if they didn't get it right away a long time ago"
    },
    "116": {
        "startTime": 845.0,
        "endTime": 858.0,
        "transcript": "Tau͡gaam kinguakun nallunriraqamiu quyapiatuukut yugni tamamta uumek nallunriraqamteggu mat'um.",
        "translation": "But when they know later, all of us people are thankful when they find out [about this goodness]."
    },
    "117": {
        "startTime": 858.5,
        "endTime": 871.0,
        "transcript": "Tua-i-llu maa-i watua ilaput elluarucimek aturarkameggnek upteqcaartu'rtut.",
        "translation": "And now, some of us are preparing good things that they will use."
    },
    "118": {
        "startTime": 871.5,
        "endTime": 876.5,
        "transcript": "Wangkuta-llu waten tegganrulriani tamatumun",
        "translation": "And we elders [must do] that"
    },
    "119": {
        "startTime": 877.5,
        "endTime": 885.0,
        "transcript": "Atunem-llu malrukuk ukuk, pingayun, wall'u-qaa qavciukuneng angutet",
        "translation": "And when two, three, or several men are together"
    },
    "120": {
        "startTime": 885.7,
        "endTime": 899.5,
        "transcript": "Tauna upyuskengaat qanerturautekluku piaqamta imutun elaqvaqanilriatun pituaput",
        "translation": "When we discuss what they are preparing, it's like we're spreading it"
    },
    "121": {
        "startTime": 900.4,
        "endTime": 905.5,
        "transcript": "Maligcugnarqerkaungan tauna caliarteng.",
        "translation": "Because their work inspires others."
    },
    "122": {
        "startTime": 906.0,
        "endTime": 919.8,
        "transcript": "Tua-i-llu wangkuta tua-i tamana upyutarkaqerput makut elluarucit aturarkaput aturyuumirarkaurrluki.",
        "translation": "And then we must prepare those good things that we will use so that they will inspire others."
    },
    "123": {
        "startTime": 920.3,
        "endTime": 922.0,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "124": {
        "startTime": 924.0,
        "endTime": 930.5,
        "transcript": "…[ilait] mat'um nalliini ellangellemtun ayuqenrirtut makut yuut.",
        "translation": "…[some of] these people these days are not like those in my earliest memories."
    },
    "125": {
        "startTime": 932.4,
        "endTime": 935.0,
        "transcript": "Unguvanerkelliluteng tuaten.",
        "translation": "They even have a shorter life span."
    },
    "126": {
        "startTime": 936.0,
        "endTime": 943.0,
        "transcript": "Avani ellangellemni wii arnassagarnek angukara'urlurnek-llu tangaatullruunga",
        "translation": "Back in my earliest memories, I used to see old women and men"
    },
    "127": {
        "startTime": 943.5,
        "endTime": 949.0,
        "transcript": "Ciisquteng tau͡gaam ayapertuarluki tarritetulinek nengcuunateng.",
        "translation": "Ones who only walked supporting themselves with their knees that didn't stretch out."
    },
    "128": {
        "startTime": 950.0,
        "endTime": 952.0,
        "transcript": "Ayaruunateng tau͡gken.",
        "translation": "Yet they had no walking staffs."
    },
    "129": {
        "startTime": 953.0,
        "endTime": 957.7,
        "transcript": "Qaillun tayima tamakut allrakungqelartat?",
        "translation": "How old would they be?"
    },
    "130": {
        "startTime": 957.8,
        "endTime": 962.0,
        "transcript": "Hundred-aaq-wa cipluku allrakungqellriit nallunailngurmek.",
        "translation": "They were certainly over 100 years old."
    },
    "131": {
        "startTime": 962.5,
        "endTime": 970.5,
        "transcript": "Qavcin au͡gkut 100-aaq cipluku allrakulget tanglallrenka tamakutun ayuqenritut.",
        "translation": "Several who are over 100 years old that I used to see are not like those."
    },
    "132": {
        "startTime": 970.9,
        "endTime": 974.9,
        "transcript": "Neng'enqeggluteng, ayarurluteng tau͡gaam tarritaqluteng.",
        "translation": "Their [legs] can stretch, and they walk with canes."
    },
    "133": {
        "startTime": 975.0,
        "endTime": 978.0,
        "transcript": "Ciisquteng ayaperluki tarricuunateng.",
        "translation": "They don't support themselves with their knees when they walk."
    },
    "134": {
        "startTime": 981.0,
        "endTime": 989.5,
        "transcript": "Cam, cam wangkuta maani angukara'urluirucetakut mat'um nalliini?",
        "translation": "I wonder what makes us lack old men these days?"
    },
    "135": {
        "startTime": 991.4,
        "endTime": 996.5,
        "transcript": "Nallunaitqapiarmek Qaneryaram qanrutaakut waten:",
        "translation": "The Bible very clearly tells us this:"
    },
    "136": {
        "startTime": 996.8,
        "endTime": 1007.0,
        "transcript": "Angayuqamteńek, aanamteńek, atamteńek-llu narurcillerput pitekluku yuucirput kepumalartuq nanilicaumaluni.",
        "translation": "Because we disobey our parents, mothers, and fathers, our lives get cut short."
    },
    "137": {
        "startTime": 1008.7,
        "endTime": 1012.0,
        "transcript": "Wangkuta tau͡gaam anglanakevvut maliggluku.",
        "translation": "We only do what we think is fun."
    },
    "138": {
        "startTime": 1013.0,
        "endTime": 1024.5,
        "transcript": "Au͡gkut angayuqamta aanamta-llu nunulriatun pitarrluta qalarut'lallruitkut akaarnun yuuqaasqumaluta.",
        "translation": "Our parents and mothers back then talked to us as if they were scolding us because they wanted us to live long lives."
    },
    "139": {
        "startTime": 1025.0,
        "endTime": 1030.0,
        "transcript": "Cunawa tuaten kenekngamegtekut qalarut'lallrukaitkut.",
        "translation": "Turns out, they talked to us like that because they loved us."
    },
    "140": {
        "startTime": 1030.9,
        "endTime": 1038.5,
        "transcript": "Au͡gna piqaqerlaku waten niitelqa aviukaqsaraq.",
        "translation": "Let me touch on what I heard about food and water offerings."
    },
    "141": {
        "startTime": 1039.0,
        "endTime": 1044.0,
        "transcript": "Avani tamana atullruat, wiinga-llu tangaatullruunga.",
        "translation": "They used to do that a long time ago, and I used to see it."
    },
    "142": {
        "startTime": 1044.5,
        "endTime": 1051.0,
        "transcript": "Tau͡gken angayuqaagka tuaten piyuunatek, aviukaqsuunatek ak'a taringellrulliniamek.",
        "translation": "However, my parents would not make food or water offerings like that because they had already understood."
    },
    "143": {
        "startTime": 1052.0,
        "endTime": 1061.5,
        "transcript": "Una wani aviukaqsaraq waten atullrulliniata: yugmun taumun tuqullermun piicagluteng.",
        "translation": "Food and water offerings were evidently done like this: they prayed to that person who had died."
    },
    "144": {
        "startTime": 1062.0,
        "endTime": 1076.0,
        "transcript": "Piicagluteng assirluteng yuuyugluteng, naulluuvkenateng yuuyugluteng, wall'u picugluteng pillalliniit kaigavikluku yuk tuqumalria",
        "translation": "They prayed for good lives, lives without sickness, or they prayed to and entreated a dead person"
    },
    "145": {
        "startTime": 1076.5,
        "endTime": 1081.5,
        "transcript": "Ayuqucirtuumanrilameng-wa kaigallerkameggnek.",
        "translation": "Because they were not instruction on [religious] entreaty."
    },
    "146": {
        "startTime": 1082.0,
        "endTime": 1087.5,
        "transcript": "Tau͡gaam Jesus-aaq tekicami qanertuq ellii tumyaraurrniluni.",
        "translation": "But when Jesus arrived, he said that he had become the way."
    },
    "147": {
        "startTime": 1088.0,
        "endTime": 1095.0,
        "transcript": "Elliikun camek kaigakumta elliin cikirarkauniluta piyullemteńek.",
        "translation": "If we entreat through him, he will give us what we want."
    },
    "148": {
        "startTime": 1095.5,
        "endTime": 1101.0,
        "transcript": "Tuaten ayuqellrulliniuq au͡gna piicagyaraqellrulliniluku.",
        "translation": "That's what it was like, a form of prayer."
    },
    "149": {
        "startTime": 1101.5,
        "endTime": 1107.7,
        "transcript": "Una Agayun nallunricaaqaat ciuliamta Ellam Yuanek aterpaggluku.",
        "translation": "Our ancestors know God as the Spirit of the Universe."
    },
    "150": {
        "startTime": 1108.0,
        "endTime": 1115.0,
        "transcript": "Una tau͡gaam Jesus-aaq ukaqvaggun alaillruan nallullrulliniat ciuliamta.",
        "translation": "But because Jesus appeared recently, our ancestors didn't know him."
    },
    "151": {
        "startTime": 1116.0,
        "endTime": 1121.4,
        "transcript": "Niiteqarraalallermeggni-llu Jesus-aaq kiulallrulliniut qanerluteng",
        "translation": "They said that when they first heard about Jesus, they would say in reply"
    },
    "152": {
        "startTime": 1121.5,
        "endTime": 1125.5,
        "transcript": "“Ca tauna yuk angssiyaagluni yuuga?”",
        "translation": "“Why is that person's life so important?”"
    },
    "153": {
        "startTime": 1126.0,
        "endTime": 1128.5,
        "transcript": "Taringumanrilamegteggu-wa.",
        "translation": "It was because they didn't understand it."
    },
    "154": {
        "startTime": 1129.2,
        "endTime": 1135.8,
        "transcript": "Taumek tamatumek tuaten ayuqluku taringumaaqa.",
        "translation": "That is how I understand it."
    },
    "155": {
        "startTime": 1135.9,
        "endTime": 1145.0,
        "transcript": "Tuamta-llu atauciq cali yuumaqeryaraq atunriamteggu arcaqerluku mat'um nalliini.",
        "translation": "And because we've stopped doing one thing that makes us live longer, especially these days."
    },
    "156": {
        "startTime": 1146.5,
        "endTime": 1159.0,
        "transcript": "Au͡gkut ciuliamta arnat wall'u angutet ayagyuat yuuyugaqameng ak'anun nunaseng man'a murilketullrulliniat.",
        "translation": "Our ancestors back then, when young women or men wanted to live long lives, they would watch over their land here."
    },
    "157": {
        "startTime": 1159.5,
        "endTime": 1165.0,
        "transcript": "Carangllugcetevkenaku-llu, nunat-llu akuliit clean up-aatuluku.",
        "translation": "They didn't leave garbage in it, and they cleaned up the areas in settlements."
    },
    "158": {
        "startTime": 1165.5,
        "endTime": 1172.5,
        "transcript": "Ataucimun ciqitaqluki tamakut caranglluut yuum tutmalqenrilkiinun.",
        "translation": "They would dump that garbage in one place where no one had trod."
    },
    "159": {
        "startTime": 1172.6,
        "endTime": 1176.5,
        "transcript": "Ciuliamta-llu alerquutekluku tamana tuaten.",
        "translation": "That was what our ancestors instructed too."
    },
    "160": {
        "startTime": 1177.0,
        "endTime": 1183.0,
        "transcript": "Nunat clean up, nunam mat'um clean up-aarturallra alerquutekluku.",
        "translation": "Cleaning up the land here was [one of] their instructions."
    },
    "161": {
        "startTime": 1183.7,
        "endTime": 1189.6,
        "transcript": "Tamaa-i-nguuq au͡gkut ciuliamta yuunertutiita iqua.",
        "translation": "That is the meaning of our ancestors' long lives back then."
    },
    "162": {
        "startTime": 1190.0,
        "endTime": 1198.5,
        "transcript": "Agayutem man'a nuna pikngamiu wangkutnun carangllirluku uqlarluku-llu atuusqenritaa.",
        "translation": "Because God owns this land, he doesn't want us to leave it trashed or polluted."
    },
    "163": {
        "startTime": 1199.0,
        "endTime": 1203.0,
        "transcript": "Menuunaku ciuliamcetun atuusqumauq.",
        "translation": "It must be left pristine like our ancesotrs."
    },
    "164": {
        "startTime": 1203.5,
        "endTime": 1209.4,
        "transcript": "Tuaten-llu ayuqekumta, qanruyutengqertukut ciuliamteńek",
        "translation": "And if we're like that, we have traditional wisdom from our ancestors"
    },
    "165": {
        "startTime": 1209.5,
        "endTime": 1214.0,
        "transcript": "Tuaten ayuqekumta-gguq akaarnun yuuqerciqukut.",
        "translation": "They said that if we're like that, we will live long lives."
    },
    "166": {
        "startTime": 1214.5,
        "endTime": 1219.0,
        "transcript": "Temvut-llu una pinirluni nangengqaarkauluni.",
        "translation": "Our bodies will also be standing strong."
    },
    "167": {
        "startTime": 1219.7,
        "endTime": 1228.5,
        "transcript": "Ilaput-llu naulluum, naulluunangraata-gguq tuaten ayuqekumta tamatum naulluutiita agturngaitaakut.",
        "translation": "And they said that even if those around us are sick, that sickness will not affect us if we're like that."
    },
    "168": {
        "startTime": 1229.0,
        "endTime": 1240.7,
        "transcript": "Agayutem tamaa-i quyatiin mat'umek nunaminek wangkutnun navriuteklerminek menuunaku aturtelluku yugnun.",
        "translation": "That is God's gratitude for people keeping his land pristine that he has lent us."
    },
    "169": {
        "startTime": 1241.0,
        "endTime": 1248.4,
        "transcript": "Agayutem-gguq tamana quyatekaa yugmun taumun akaarnun unguvaqertelluku.",
        "translation": "They say that God's gratitude toward that person is having him live a long life."
    },
    "170": {
        "startTime": 1248.5,
        "endTime": 1259.5,
        "transcript": "Tuamta-llu tamana taperluni apqiitnek nukalpiaruluni wall'u piculuni angutnguli arnauli-llu ayuqlukek.",
        "translation": "And on top of that, what they call great hunters or those who are good at catching animals, both men and women."
    },
    "171": {
        "startTime": 1260.0,
        "endTime": 1269.8,
        "transcript": "Tuaten akiliumalalliniluku Agayutem yuk nunamek mat'umek kenagciuralria.",
        "translation": "God apparently rewards a person like that who cleans up this land."
    },
    "172": {
        "startTime": 1269.9,
        "endTime": 1274.0,
        "transcript": "Ukanirpak man'a engelkarrluku alerquutnguyaaquq.",
        "translation": "It's an ancient traditional instruction to this day."
    },
    "173": {
        "startTime": 1275.5,
        "endTime": 1286.0,
        "transcript": "Au͡gna-llu niitellerput, “Atan aanan-llu takaqikek unguvamanaurtuten nunami Jehovah-m agayutvet elpenun cikiutekellrani.”",
        "translation": "And we heard, “Honor your father and mother so that you will live long in this land that Jehovah your god has given you.”"
    },
    "174": {
        "startTime": 1286.5,
        "endTime": 1295.0,
        "transcript": "Tuaten ayuqekuvet qanrucunaquvet man'a iirumayuinaitarput wangkuta yumteńun…",
        "translation": "If you are obedient like that, we should not hide this from our children…"
    }
};